import { InputText, Toast } from '@fattureincloud/fic-design-system'
import { InputHelperProps } from '@fattureincloud/fic-design-system/dist/components/form/inputHelper'
import React, { FC, useEffect, useState } from 'react'

import { httpRequest } from '../../common/network'
import { isNumeric } from '../../common/utils'
import { errorMessage, locale } from '../../locales/locale'
import { HelpModal } from '../common.components'
import { MoveMainPage } from './dnd.components'

interface Props {
  onClose: () => void
  type: 'sezione' | 'articolo'
  onSuccess: () => void
  articleId: number
  sectionId: number
}

const ChangeParentSectionModal: FC<Props> = (props: Props) => {
  const [newParentSection, setNewParentSection] = useState<string>('')
  const [parentHelper, setParentHelper] = useState<InputHelperProps>(undefined)
  const [inMainPage, setInMainPage] = useState<boolean>(false)

  const defaultParentHelper: InputHelperProps = {
    message:
      locale("Inserisci l'ID della nuova sezione di appartenenza.") + ' ' + 
      locale('Premi invio per verificare il titolo della sezione.'),
    status: 'info',
  }
  useEffect(() => {
    setParentHelper(defaultParentHelper)
  }, [])

  const isParentSectionValid = () => {
    return isNumeric(newParentSection)
  }

  const parentSectionError = () => {
    const valid = isParentSectionValid()
    if (valid) {
      setParentHelper(defaultParentHelper)
      return false
    }
    setParentHelper({
      message: locale('Inserisci un numero'),
      status: 'error',
    })
    return true
  }

  const saveParentSection = (type: 'articolo' | 'sezione') => {
    if (!inMainPage) {
      const error = parentSectionError()
      if (error) return
    }
    const url =
      type === 'articolo'
        ? `help/article/${props.articleId}/parent_section`
        : `help/sections/${props.sectionId}/parent_section`
    httpRequest({
      method: 'PUT',
      path: url,
      data: {
        parent_section: inMainPage ? null : newParentSection,
      },
      onSuccess: () => {
        Toast.success(locale('Parent section modificata'))
        props.onSuccess()
      },
      onError: (res) => {
        Toast.error(errorMessage, { content: res.message })
      },
    })
  }

  const keyPressHandler = (e: React.KeyboardEvent) => {
    if (e.key !== 'Enter') return
    if (newParentSection === '') {
      setParentHelper(defaultParentHelper)
      return
    }
    httpRequest({
      method: 'GET',
      path: `help/sections/${newParentSection}/title`,
      onSuccess: (res: { data: string | null }) => {
        if (res.data !== null)
          setParentHelper({ status: 'success', message: res.data })
        else
          setParentHelper({
            status: 'error',
            message: locale('Nessuna sezione corrispondente trovata'),
          })
      },
      onError: (res) => Toast.error(errorMessage, { content: res.message }),
    })
  }

  return (
    <HelpModal
      title={locale('Cambia Parent Section')}
      onActionClose={() => props.onClose()}
      footerButtons={[
        {
          text: locale('Salva'),
          color: 'green',
          onClick: () => {
            saveParentSection(props.type)
          },
        },
      ]}
    >
      <InputText
        label={locale('Parent section')}
        value={inMainPage ? '' : newParentSection}
        inputType={'number'}
        onChange={(e) => setNewParentSection(e.target.value)}
        onKeyPress={(e) => keyPressHandler(e)}
        helper={parentHelper}
        disabled={inMainPage}
      />
      {props.type === 'sezione' && (
        <MoveMainPage
          value={inMainPage}
          text={locale('Sposta nella pagina principale')}
          onChange={() => setInMainPage(!inMainPage)}
        />
      )}
    </HelpModal>
  )
}

export default ChangeParentSectionModal
